import styles from "./TestimonialList.module.css";
import PropTypes from "prop-types";

export default function TestimonialList({ testimonials }) {
  return (
    <div className={styles.testimonialList}>
      {testimonials.map((testimonial) => {
        return (
          <div key={testimonial.testimonial} className={styles.testimonialItem}>
            <p className={styles.company}>{testimonial.company}</p>
            <p className={styles.copy}>{testimonial.testimonial}</p>
            {testimonial.name && (
              <p className={styles.name}>
                {testimonial.name}
                {testimonial.position && <span> - {testimonial.position}</span>}
              </p>
            )}
            {testimonial.position && !testimonial.name && (
              <p className={styles.name}>{testimonial.position}</p>
            )}
          </div>
        );
      })}
    </div>
  );
}

TestimonialList.propTypes = {
  testimonials: PropTypes.arrayOf(
    PropTypes.shape({
      company: PropTypes.string.isRequired,
      testimonial: PropTypes.string.isRequired,
      name: PropTypes.string,
      position: PropTypes.string,
    }),
  ).isRequired,
};
